import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { waitFor } from 'lp-hoc'
import { selectors as globalSelectors } from 'artist-portal-reducer'
import * as Types from 'types'
import { LoadingSpinner } from 'components'
import { DashboardMap } from '../components'

const propTypes = {
  artist: Types.artist,
  locations: PropTypes.arrayOf(Types.location),
}

const defaultProps = {
  locations: [],
}

function Summary({ artist, locations }) {
  return <DashboardMap locations={locations} artistId={artist.id} />
}

Summary.propTypes = propTypes
Summary.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    artist: globalSelectors.artist(state),
    locations: globalSelectors.allLocations(state),
  }
}

export default compose(
  connect(mapStateToProps),
  waitFor('artist', LoadingSpinner)
)(Summary)
